import { Typography } from '@material-ui/core'
import { ViewGroupItemContainer } from './style'

const ViewUserItem = ({ label, value, color1, color2, style1, style2, onClick, fontWeight}: any) => {
  return (
    <ViewGroupItemContainer>
      <Typography
        style={{
          color: color1,
          ...style1
        }}
      >
        {label}&nbsp;
      </Typography>
      <Typography
        onClick={e => onClick && onClick(e)}
        style={{
          color: color2,
          fontWeight: 'bold',
          ...style2
        }}
      >
        {value}
      </Typography>
    </ViewGroupItemContainer>
  )
}

export default ViewUserItem
